<template>
   <div class="card-list-section">
      <!--Header-->
      <h2
         v-if="content.header"
         :id="generateId(content.header)"
         :class="[
            'card-list-section__header',
            { 'custom-text-position': textAlign },
            { 'adjust-margin': adjustMargin },
         ]"
      >
         {{ content.header }}
      </h2>

      <!--Paragraph-->
      <p v-if="content.shortDescription" class="card-list-section__para">
         {{ descriptionJoiner(content.shortDescription) }}
      </p>

      <!--Cards Wrapper-->
      <ul class="card-list-section__cards-wrapper">
         <!--Card-->
         <li
            v-for="(item, index) in content.cards"
            ref="layout"
            :key="index"
            :class="[
               'card-container card-anatomy',
               { 'card-animation': hide && show && !verticalCard },
               { 'horizontal-card-width feature-card-shadow': horizontalCard },
               { 'change-layout': requiredFourColumnsPerRow },
            ]"
         >
            <!--Image part-->
            <img
               v-if="hide && show && !verticalCard"
               :src="item.imgUrl"
               alt=""
               class="card-anatomy__image"
               :class="[{ 'image-fix': imageFix }]"
               width="200"
               height="200"
            />

            <!--Special Block-->
            <div
               v-if="!(hide && show) || verticalCard"
               class="card-anatomy__special-block"
               :class="[{ 'horizontal-card': horizontalCard }]"
            >
               <!--Svg-->
               <div
                  v-if="horizontalCard || verticalCard"
                  :class="['svg-icon-block', { 'svg-icon-for-vertical': verticalCard }]"
               >
                  <span
                     class="svg-icon-size"
                     :class="[
                        item.cardIcon || generateIcons(iconsArray, index),
                        { 'svg-icon-position': verticalCard },
                     ]"
                  ></span>
               </div>

               <!--Text-->
               <p v-if="horizontalCard" class="text-description">
                  {{ item.cardDescription }}
               </p>

               <!--Font Icon-->
               <i
                  v-if="requiredFontIcon"
                  class="circle-shape font-icon-brought-center"
                  :class="item.icon || generateIcons(iconsArray, index)"
               ></i>
            </div>

            <!--Body part-->
            <div
               v-if="hide"
               class="card-anatomy__body"
               :class="[{ 'reduce-padding': requiredFontIcon }, { 'padding-fix': imageFix }]"
            >
               <h3
                  class="body__header"
                  :class="[
                     { 'text-color': requiredFontIcon },
                     { 'text-color-vertical': verticalCard },
                     { 'special-header-font': specialHeaderFont },
                  ]"
               >
                  {{ item.cardHeader }}
               </h3>

               <h3 v-if="item.cardAnotherHeader" class="special-header">
                  {{ item.cardAnotherHeader }}
               </h3>

               <p
                  v-if="item.cardDescription"
                  :class="['body__text', { 'body__text-vertical': verticalCard }]"
               >
                  {{ item.cardDescription }}
               </p>
            </div>

            <!--Footer Part-->
            <div
               v-if="hide && !verticalCard"
               class="card-anatomy__footer"
               :style="{ minHeight: '48px' }"
            >
               <!-- <a href="" >
                  modalDownloadForm
               </a> -->
               <a
                  v-if="item.cardUrl && item.slug"
                  :href="item.cardUrl"
                  class="btn btn-secondary-grad modified-btn mr-1 mb-1"
                  @click.prevent="goTo(item.cardUrl, $event)"
                  >SEE LIVE DEMO</a
               >
               <a
                  :href="(item.ctas && item.ctas[0].link) || item.cardUrl"
                  class="btn btn-outline-secondary modified-btn mb-1"
                  @click.prevent="
                     item.slug
                        ? openModal(index) // $refs['bv-modal-' + index].show() // $BModal.show('bv-modal-' + index)
                        : goTo((item.ctas && item.ctas[0].link) || item.cardUrl, $event)
                  "
                  >{{ (item.ctas && item.ctas[0].header) || generateCtaName(ctaName, index) }}</a
               >

               <a
                  v-if="item.downloadLink"
                  :href="item.downloadLink"
                  class="btn btn-secondary-grad modified-btn mb-1 ml-1"
                  @click.prevent="goTo(item.downloadLink)"
                  >Download</a
               >

               <!-- <a
                  :href="item.cardUrl"
                  class="btn btn-outline-secondary modified-btn mb-1"
                  @click.prevent="item.slug ? openModal(index) : goTo(item.cardUrl, $event)"
                  >{{ generateCtaName(ctaName, index) }}fff</a
               >
               <a
                  v-for="(cta, _index) in item.ctas"
                  :key="_index"
                  :href="(cta && cta.link) || item.cardUrl"
                  class="btn btn-outline-secondary modified-btn mb-1"
                  @click.prevent="
                     item.slug
                        ? openModal(index) // $refs['bv-modal-' + index].show() // $BModal.show('bv-modal-' + index)
                        : goTo((cta && cta.link) || item.cardUrl, $event)
                  "
                  >{{ (cta && cta.header) || generateCtaName(ctaName, index) }}kkk</a
               > -->
            </div>
         </li>
      </ul>
      <div v-for="(item, index) in content.cards" v-if="item.slug" :key="index">
         <b-modal :ref="'bv-modal-' + index" centered hide-footer>
            <DownloadForm :slug="item.slug" :dashboard-name="item.cardHeader" />
         </b-modal>
      </div>
   </div>
</template>

<script>
import DownloadForm from '../forms/DashboardDownload';

export default {
   name: 'Card',
   components: {
      DownloadForm,
   },
   props: {
      content: {
         type: Object,
         default: () => ({ header: '' }), // Ensures header is always defined for SSR
      },
      ctaName: {
         type: [String, Array],
         default: 'see demo',
      },
      imageFix: {
         type: Boolean,
         default: false,
      },
      requiredFontIcon: {
         type: Boolean,
         default: false,
      },
      iconsArray: {
         type: Array,
         default: () => [],
      },
      requiredFourColumnsPerRow: {
         type: Boolean,
         default: false,
      },
      horizontalCard: {
         type: Boolean,
         default: false,
      },
      verticalCard: {
         type: Boolean,
         default: false,
      },
      openSeperateTab: {
         type: Boolean,
         default: false,
      },
      // remove this 'textAlign' prop if no other component is sending and also related css classes. it is using for custom css styling
      textAlign: {
         type: Boolean,
         default: false,
      },
      // remove this 'adjustMargin' prop if no other component is sending and also related css classes. it is using for custom css styling
      adjustMargin: {
         type: Boolean,
         default: false,
      },
      // remove this 'specialHeaderFont' prop if no other component is sending and also related css classes. it is using for custom css styling
      specialHeaderFont: {
         type: Boolean,
         default: false,
      },
   },
   data() {
      return {
         generateFourColumns: false,
         hide: false,
         show: false,
         modalDownloadForm: false,
      };
   },
   watch: {
      // if four cards are required, then pass a prop
      generateFourColumns() {
         this.$refs.layout.forEach(item => item.style.setProperty('--layout', 4));
      },
   },
   mounted() {
      this.generateFourColumns = this.requiredFourColumnsPerRow;

      // here hide is getting false value, to disable unnecessary parts
      this.hide = !this.horizontalCard;
      this.show = !this.requiredFontIcon;
   },

   methods: {
      generateIcons(arr, index) {
         return arr[index];
      },
      generateCtaName(val, index) {
         let buttonName;

         // if it is string
         if (typeof val === 'string') {
            buttonName = val;

            return buttonName;
         }
         // else return array
         buttonName = val[index];
         return buttonName;
      },
      goTo(url, evt) {
         const reload = this.$reloadType(url);
         if (this.openSeperateTab || reload) {
            window.open(url, '_blank');
         } else {
            this.$router.push(url).catch(err => {});
         }
      },
      generateId(val) {
         return val
            .split(' ')
            .join('-')
            .toLowerCase();
      },
      openModal(id) {
         this.$refs[`bv-modal-${id}`][0].show();
         // $refs['bv-modal-' + index].show() // $BModal.show('bv-modal-' + index)
      },
      // getDownloadLink(header) {
      //    const links = {
      //       fusioncharts: '/download/fusioncharts-suite-xt',
      //       fusiontime: '/download/fusiontime',
      //       fusionexport: '/download/fusionexport',
      //       'fusioncharts.net':
      //          'https://www.fusioncharts.com/dev/fusioncharts-aspnet-visualization/getting-started/install-fusioncharts-net',
      //    };
      //    header.toLowerCase().indexOf('');
      // },
   },
};
</script>

<style lang="scss" scoped>
.card-list-section {
   &__header {
      line-height: 33px;
   }
   &__para {
      margin-bottom: 0;
      letter-spacing: 0.2px;
      line-height: 26px;
      color: #434456;
   }
   &__cards-wrapper {
      list-style-type: none;
      padding-left: 0;
      margin-bottom: 0;
      margin: 0 -11.9px;
      display: flex;
      flex-wrap: wrap;

      //Card Container
      .card-container {
         --layout: 4;
         width: calc(100% / var(--layout, 4) - 23.8px);
         background-color: #ffffff;
         margin: 24px 11.9px 0;
         border-radius: 4.49px;
         box-shadow: 0 11px 15px 0 rgba(62, 57, 107, 0.04);
         display: flex;
         flex-direction: column;
         background-color: white;
         box-shadow: 0 8px 10px 0 rgba(105, 87, 218, 0.06);
         min-height: 400px;

         @media (max-width: 800px) {
            width: calc(100% / 2 - 23.8px);
         }
         @media (max-width: 500px) {
            width: calc(100%);
         }
      }
      .card-anatomy {
         //Image
         &__image {
            padding: 20px 20px;
            width: 100%;
            height: 200px;
         }

         // font icon block
         &__special-block {
            padding: 24px 24px 0;
         }

         // Body
         &__body {
            padding: 0 24px 24px;
            // which make it to grow, ralative to other cards. this property makes equal height columns
            flex-grow: 1;
            .body__header {
               font-size: 1.6rem;
               font-weight: 600;
               letter-spacing: 0.23px;
               line-height: 20px;
            }
            .special-header {
               letter-spacing: 0.27px;
               line-height: 20px;
               font-size: 16px;
               color: #434456;
               font-weight: 600;
               margin-top: 11px;
            }
            .body__text {
               margin-bottom: 0;
               color: #686980;
               letter-spacing: 0.23px;
               font-size: 14px;
               line-height: 22px;
            }
            // text-color and font size...etc for vertical card
            .body__text-vertical {
               font-size: 14px;
               color: #73748c;
               line-height: 22px;
            }
         }

         // Footer
         &__footer {
            padding: 0 24px 24px;
            .modified-btn {
               padding: 8px 11.9px;
               font-size: 1.3rem;
               line-height: 16px;
            }
         }
      }
   }
   //card animation
   .card-animation {
      transition: all ease 0.3s;
      &:hover {
         transform: translateY(-4px);
      }
   }

   //image fix
   .image-fix {
      padding: 0;
      height: auto;
   }

   //padding-fix
   .padding-fix {
      padding: 20px 24px 14px;
   }

   //circle shape
   .circle-shape {
      width: 50px;
      height: 50px;
      border: 1px solid black;
      display: block;
      border-radius: 50%;
      border: 1px solid rgba(105, 87, 218, 0.06);
      box-shadow: 0 8px 10px 0 rgba(62, 57, 107, 0.04);
      &::before {
         background: linear-gradient(134.72deg, #bb88fd, #6957da);
         -webkit-background-clip: text;
         background-clip: text;
         -webkit-text-fill-color: transparent;
      }
   }

   //text color
   .text-color {
      color: #6957da;
   }

   //text-color-vertical
   .text-color-vertical {
      //text color for vertical card
      color: #434456;
   }

   //reduce-padding
   .reduce-padding {
      padding: 15px 24px 24px;
   }

   .font-icon-brought-center {
      text-align: center;

      //line-height should be equal to size(height) of the block
      line-height: 50px;
   }

   //horizontal card
   .horizontal-card {
      display: flex;
      padding: 0;
      align-items: center;
      // box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.04);
      border: 0.9px solid rgba(62, 57, 107, 0.04);
      border-radius: 4.49px;
      // it makes all cards height equal
      height: 100%;
   }

   // horizontal-card width for 1199px and 600px
   .horizontal-card-width {
      @media (max-width: 1399px) {
         width: calc(100% / 2 - 23.8px);
      }
      @media (max-width: 600px) {
         width: calc(100%);
      }
   }

   //svg icon block
   .svg-icon-block {
      margin-left: 15px;
   }

   //svg-icon-for-vertical
   .svg-icon-for-vertical {
      //to remove initial margin-left:15px, we are using this class for vertical card
      margin-left: 0;
      margin-bottom: 13px;
      min-height: 80px;
   }

   //svg icon size
   .svg-icon-size {
      // if all svg icon sizes are equal then write css properties for width and height here. other use default
      display: block;
   }

   //svg-icon-position
   .svg-icon-position {
      margin: 0 auto;
   }

   //text-description
   .text-description {
      margin: 0;
      padding: 15px;
   }
   .change-layout {
      @media (max-width: 1255px) {
         width: calc(100% / 2 - 23.8px);
      }
      @media (max-width: 500px) {
         width: calc(100%);
      }
   }
   .feature-card-shadow {
      box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.01);
   }
}
// classes for custom and sending as props

.adjust-margin {
   margin: 0 auto 20px auto;
}

.special-header-font {
   font-size: 1.9rem !important;
   line-height: 24px !important;
}

// sprite css
%icon {
   background-repeat: no-repeat;
   background-image: url('../../../public/images/product-gallery1.svg');
}
.icon-eight,
.icon-eight\:regular {
   @extend %icon;
   background-position: 0 0;
}
.icon-eight-dims {
   width: 113px;
   height: 67px;
}
.icon-eleven,
.icon-eleven\:regular {
   @extend %icon;
   background-position: 0 -67px;
}
.icon-eleven-dims {
   width: 98px;
   height: 76px;
}
.icon-five,
.icon-five\:regular {
   @extend %icon;
   background-position: 0 -143px;
}
.icon-five-dims {
   width: 98px;
   height: 72px;
}
.icon-four,
.icon-four\:regular {
   @extend %icon;
   background-position: 0 -215px;
}
.icon-four-dims {
   width: 102px;
   height: 64px;
}
.icon-nine,
.icon-nine\:regular {
   @extend %icon;
   background-position: 0 -279px;
}
.icon-nine-dims {
   width: 118px;
   height: 76px;
}
.icon-one,
.icon-one\:regular {
   @extend %icon;
   background-position: 0 -355px;
}
.icon-one-dims {
   width: 103px;
   height: 66px;
}
.icon-seven,
.icon-seven\:regular {
   @extend %icon;
   background-position: 0 -421px;
}
.icon-seven-dims {
   width: 104px;
   height: 65px;
}
.icon-six,
.icon-six\:regular {
   @extend %icon;
   background-position: 0 -486px;
}
.icon-six-dims {
   width: 102px;
   height: 68px;
}
.icon-ten,
.icon-ten\:regular {
   @extend %icon;
   background-position: 0 -554px;
}
.icon-ten-dims {
   width: 105px;
   height: 79px;
}
.icon-three,
.icon-three\:regular {
   @extend %icon;
   background-position: 0 -633px;
}
.icon-three-dims {
   width: 112px;
   height: 82px;
}
.icon-two,
.icon-two\:regular {
   @extend %icon;
   background-position: 0 -715px;
}
.icon-two-dims {
   width: 101px;
   height: 70px;
}
.card-list-section__header {
   min-height: 48px; /* Increased for better LCP/CLS stability */
}
</style>
